import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';

import csmUtilTools from '../../util/tools/tools';
import dateInputTemplate from './dateInput.template.html';
import './dateInput.css';

export default angular
  .module('csm.ui.dateInput', [uiBootstrap, csmUtilTools])

  /*------------------------------------*/
  /* Change the uibDateParser such that */
  /* it uses the parseDate routine.     */
  /*------------------------------------*/
  .decorator('uibDateParser', function ($delegate, Tools) {
    $delegate.parse = function (input) {
      return Tools.parseDate(input);
    };
    return $delegate;
  })

  /*------------------------------------------------*/
  /* Decorate the uibDatePicker directive so that   */
  /* the render method will be called to initialize */
  /* the calendar to the current model value        */
  /*------------------------------------------------*/
  .decorator('uibDatepickerDirective', function ($delegate) {
    var mBaseLink = $delegate[0].link;

    $delegate[0].compile = function () {
      return function (scope, element, attrs, ctrls) {
        mBaseLink.apply(this, arguments);
        ctrls[0].render();
      };
    };

    return $delegate;
  })

  /*******************************************************************************
   * Directive: dateInput
   *
   * Provides an input and a button to toggle the uibDatePicker calendar for
   * working with dates. The input allows for the date to be enter via keyboard
   * but must follow this format: mm/dd/yyyy.
   *
   * The ngModel property passed to this directive will be populated with the
   * corresponding date from either the input or the calendar, or the entered
   * text if dateOnlyModel is not true.
   *
   * The controller is needed as a means of validation checking so other directives
   * can check if the component is valid.
   *
   * @attr  {string}    displayFormat
   *   Format string to display the date. Default is MM/dd/yyyy.
   * @attr  {bool}      reset
   *   Indication to reset the component to have no date or validation errors
   *
   * TODO: This is badly written and needs to be refactored.
   * TODO: `mInput` is never set so what is it for? (Looks like the line setting it was removed during a refactor for validators -CK)
   * TODO: Decorating the `uib` components is a bad idea since it makes everything
   * TODO: that uses them required this directive be loaded somewhere.
   *******************************************************************************/
  .directive('dateInput', function ($compile, $filter, Tools) {
    /** Date Error Class. */
    var ERROR_CLASS = 'dateError';

    return {
      restrict: 'E',
      template: dateInputTemplate,
      require: 'ngModel',
      scope: { reset: '=' },
      controller: function ($element) {
        /** Returns an indication if the component is valid by the absence of the error class. */
        this.isValid = function () {
          return !$element.hasClass(ERROR_CLASS);
        };
      },
      link: function ($scope, elem, attr, ngModelCtrl) {
        /** Input Field. */
        var mInput = null;

        /** Set Focus request for when the template loads. */
        var mSetFocus = false;

        /** Internal date model object to use with the uibDatepickerPopup */
        $scope.date = null;

        /** Calendar Opened Status. Must be an object property so it can be updated
          in the child scope. */
        $scope.status = { opened: false };

        /*-----------------------------------*/
        /* overrides the focus function to   */
        /* set focus on the input element    */
        /*-----------------------------------*/
        elem[0].focus = function () {
          if (mInput) {
            mInput[0].focus();
            mSetFocus = false;
          } else mSetFocus = true;
        };

        /*------------------------------------*/
        /* Add formatter to set date property */
        /*------------------------------------*/
        ngModelCtrl.$formatters.push(function (value) {
          return ($scope.date = Tools.parseDate(value));
        });

        /*************************************************************************
         * checkDate */
        /**
         * Add/remove error class if there is input and no parsed date.
         *************************************************************************/
        function checkDate() {
          if (mInput && mInput.val().length > 0 && !$scope.date)
            elem.addClass(ERROR_CLASS);
          else elem.removeClass(ERROR_CLASS);
        }

        /*************************************************************************
         * getFormat */
        /**
         * Returns the date display format from the specified attribute. If not
         * set, the default of 'MM/dd/yyyy' is returned.
         *
         * @return String date format
         *************************************************************************/
        $scope.getFormat = function () {
          return attr.displayFormat || 'MM/dd/yyyy';
        };

        /***********************************************************************
         * onBlur */
        /**
         * Call the render method to format and check the date.
         ***********************************************************************/
        $scope.onBlur = function () {
          ngModelCtrl.$render();
        };

        /*************************************************************************
         * $render */
        /**
         * Update the input text to display the date as indicated by the format.
         *************************************************************************/
        ngModelCtrl.$render = function () {
          /*--------------------------------*/
          /* Do not format non-parsed input */
          /*--------------------------------*/
          if (!mInput || !ngModelCtrl.$viewValue) return;

          mInput.val(
            $filter('date')(ngModelCtrl.$viewValue, $scope.getFormat())
          );

          checkDate();
        };

        /***********************************************************************
         * toggleCalendar */
        /**
         *Toggles the visibility of the date picker calendar
         ***********************************************************************/
        $scope.toggleCalendar = function () {
          $scope.status.opened = !$scope.status.opened;
        };

        /*------------------------------------------*/
        /* Watch for changes made to the date model */
        /* from the uibDatepickerPopup directive    */
        /*------------------------------------------*/
        $scope.$watch('date', function (val) {
          ngModelCtrl.$setViewValue(val);
        });

        /*----------------------------------------*/
        /* Watch for disabled/readonly attributes */
        /*----------------------------------------*/
        $scope.$watch(
          function () {
            return elem[0].hasAttribute('disabled');
          },
          function (hasAttr) {
            $scope.isDisabled = hasAttr;
          }
        );
        $scope.$watch(
          function () {
            return elem[0].hasAttribute('readonly');
          },
          function (hasAttr) {
            $scope.isReadonly = hasAttr;
          }
        );

        /*-------------------------------------------------*/
        /* Set up a watch on the reset binding. When true, */
        /* clear the input and the internal date property  */
        /*-------------------------------------------------*/
        $scope.$watch('reset', function (val) {
          if (val == true) {
            $scope.date = null;
            if (mInput) mInput.val('');
            $scope.reset = false;
            checkDate();
          }
        });

        /*-----------------------------------------*/
        /* When the popup closes, recheck the date */
        /*-----------------------------------------*/
        $scope.$watch('status.opened', function (val) {
          if (!val) ngModelCtrl.$render();
        });
      }
    };
  }).name;
